export default function ({ app, store, $axios, redirect, $config }) {
  $axios.onRequest((config) => {
    if (config.url === $config.graphQlStrapiApi) {
      // config.headers.Authorization = `Bearer ${process.env.STRAPI_API_TOKEN}`
      return
    }

    const user = store.get('user/user')
    if (!user && typeof localStorage !== 'undefined') {
      config.headers['X-VISITOR-ID'] = localStorage.getItem('VisitorId')
    }

    const language = store.get('language/locale')
    if (language) config.headers['X-Request-Language'] = language
  })

  const maxRetry = 3

  let refreshPromise = null

  $axios.onResponseError(async (error) => {
    const statusCode = Number.parseInt(error.response?.status)
    const requestUrl = error.config?.url || ''

    // skip refresh for auth endpoints to prevent infinite loops
    const isAuthEndpoint = requestUrl.includes('/api/auth/')

    if (statusCode === 401 && !isAuthEndpoint) {
      const user = store.get('user/user')

      // only attempt refresh if the user was logged in
      if (!user) {
        throw error
      }

      // if already refreshing, wait for that promise
      if (!refreshPromise) {
        refreshPromise = app.$auth
          .refresh()
          .then((result) => {
            // refresh() resolves regardless of outcome - throw so the catch below can sign out
            if (result?.kind === 'failure') {
              throw new Error('token refresh failed')
            }
          })
          .finally(() => {
            refreshPromise = null
          })
      }

      try {
        await refreshPromise
        // refresh succeeded - retry original request
        return $axios.request(error.config)
      } catch (refreshError) {
        // refresh failed - sign-out user
        await app.$auth.signout()
        store.set('cart/items', [])
        redirect('/')
        throw error
      }
    }

    // per-request retry count stored on the config object to avoid a shared counter
    // that would be incorrectly incremented across concurrent requests
    if (error.config) {
      error.config._retryCount = (error.config._retryCount || 0) + 1
      if (error.config._retryCount <= maxRetry && statusCode !== 500 && statusCode !== 400) {
        return $axios.request(error.config)
      }
    }

    throw error
  })
}
